import { useEffect, useLayoutEffect } from 'react';
import { isPlatformNodeJS } from '@utils/common';

/**
 * useLayoutEffect will trigger a warning if it's being run in components that
 * are server side rendered by next.js - this should often by fixed by solving
 * the underlying issues, as explained on the link below
 *
 * @see https://reactjs.org/link/uselayouteffect-ssr
 *
 * however in certain use cases, it is perfectly fine (or even desired) to have
 * the server side rendered component run useLayoutEffect, for instance if
 * crawlability is essential for the component, and it will still look right
 * due to usage of CSS media queries or similar
 *
 * in these cases, you can revert to using this hook, which will suppress the
 * warning in the next.js server layer
 *
 * **NOTE** that this hook does not fix the underlying potential issues of
 * using a layout effect in a component that is server side rendered; please
 * make sure that you have considered if there are alternative solutions before
 * opting for using this hook
 */
const useIsomorphicLayoutEffect = isPlatformNodeJS() ? useEffect : useLayoutEffect;

export { useIsomorphicLayoutEffect };
//# sourceMappingURL=layout-effect.js.map
